<template>
    <Dialog v-bind:value="value" @input="$emit('input', $event)"
            :title="title"
            @ok="$emit('ok')" ok-text="Fortfahren" :loading="loading"
            @cancel="$emit('input', false)">
        <slot></slot>
        <span class="d-flex pt-2">Diese Aktion kann nicht mehr rückgängig gemacht werden.</span>
    </Dialog>
</template>

<script>
import Dialog from "../../components/Dialog";

export default {
    props: {
        value: {},
        title: {type: String, default: 'Löschen ?'},
        loading: {type: Boolean, default: false}
    },
    name: "DeleteDialog",
    components: {Dialog}
}
</script>

<style scoped>

</style>